import { render, staticRenderFns } from "./BB-prioritizing.vue?vue&type=template&id=473a4e90&scoped=true&"
import script from "./BB-prioritizing.vue?vue&type=script&lang=js&"
export * from "./BB-prioritizing.vue?vue&type=script&lang=js&"
import style0 from "./BB-prioritizing.vue?vue&type=style&index=0&id=473a4e90&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "473a4e90",
  null
  
)

export default component.exports